import React from 'react'
import { Stack, TextField, useTheme } from '@mui/material'

export interface DateRangeFilterProps {
  startDate: string
  setStartDate: (date: string) => void
  endDate: string
  setEndDate: (date: string) => void
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate
}) => {
  const theme = useTheme()

  const dateInputStyles = {
    '& input::-webkit-calendar-picker-indicator': {
      filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'invert(0.4)',
      cursor: 'pointer'
    }
  }

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        variant="outlined" // Explicit variant resolves the type union compiler issue
        label="From"
        type="date"
        size="small"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={dateInputStyles}
      />
      <TextField
        variant="outlined"
        label="To"
        type="date"
        size="small"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={dateInputStyles}
      />
    </Stack>
  )
}

export default DateRangeFilter
